import { IoMdClose } from "react-icons/io";
import nodeinstance from "../nodeInstance";
import { getVisaRequestData } from "../store/Api";
import { setAppError } from "../store/userSlice";
import { useDispatch } from "react-redux";

export default function CommonreturnPopUp({
  DeletepopUp,
  setDeletePopUp,
  isRefundTrue,
  propId,
  status,
  isOpsDelete,
  setShowPromptElement
}) {
  const token = localStorage.getItem("nodeToken");
 

  const dispatch = useDispatch();
  console.log("isOpsDelete.....", isOpsDelete);

  const onSubmit = async () => {
    let reqObject = {
      status: status,
    };
    if (isOpsDelete) {
      try {
        const response = await nodeinstance.delete(
          `/dashboard/vrf-visa/deleteVRF/${propId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          dispatch(
            setAppError({
              msg: "Updates Successfully...",
              color: "success",
            })
          );
          setDeletePopUp(false);
          dispatch(getVisaRequestData(token));
        }
      } catch (error) {
        console.log("error to be seen here....", error);
        setDeletePopUp(false);
        dispatch(
          setAppError({
            msg: error.message,
            // color : "success"
          })
        );
      }
      return;
    } else {
      try {
        const response = await nodeinstance.put(
          `/dashboard/vrf-visa/updateStatus/${propId}`,
          reqObject,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          dispatch(
            setAppError({
              msg: "Updates Successfully...",
              color: "success",
            })
          );
          setDeletePopUp(false);
          setShowPromptElement(false)
          dispatch(getVisaRequestData(token));
        }
      } catch (error) {
        console.log("error to be seen here....", error);
        setDeletePopUp(false);
        dispatch(
          setAppError({
            msg: error.message,
            // color : "success"
          })
        );
      }
    }
  };

  console.log("status.........status......",status)
  
  return (
    <>
      <div
        className={`fixed z-40 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          DeletepopUp ? "flex" : "hidden"
        }`}
      >
        {/* <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative"> */}
        <div className="max-w-lg w-full h-[180px] overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setDeletePopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <h2 className="mt-5 ml-10">
            {isRefundTrue ? "ARE YOU SURE TO INITIATE REFUND" : "ARE YOU SURE TO REJECT THIS VISA REQUEST ? "}
          </h2>
          <div className="flex gap-3 w-full justify-center mt-5">
            <button
              className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red"
              onClick={() => {
                onSubmit();
              }}
            >
              {isOpsDelete ? "DELETE" : "REJECT"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
